import { CIcon } from '~/icons/types'

export const ciPlayCircle: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm3.386 10.644-5 3a.735.735 0 0 1-.755.006.747.747 0 0 1-.381-.65V9a.752.752 0 0 1 1.136-.644l5 3a.752.752 0 0 1 0 1.288Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'play-circle',
  type: 'solid'
}
